<template>
  <div id="page-product-details">
    <mapping-renewal-form
        v-model="model"
        ref="form"
        :loading="loading"
        card-title="Map Renewal"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
            @click="$router.push({ name: 'mapping-renewals.list' })"
            class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            :disabled="loading"
            @click="create"
            class="my-4"
            color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import MappingRenewalForm from "@/views/pages/mapping-renewals/MappingRenewalForm";
import NotificationMixin from "@/components/mixins/NotificationMixin";

export default {
  name: "ProductCreate",
  components: {
    MappingRenewalForm
  },
  mixins: [NotificationMixin],
  data() {
    return {
      model: {},
      loading: false,
    };
  },
  methods: {
    getParams() {
      const params = {
        ...this.model
      }

      const references = [
        'CommercialProductSource_FK',
        'CommercialProductTarget_FK',
        'Company_FK',
      ]

      references.forEach((ref) => params[ref] = this.getReferenceId(ref))

      return params;
    },
    getReferenceId(fieldName) {
      if (!this.model[fieldName]) {
        return null;
      }

      return this.model[fieldName].id || null;
    },
    async create() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      //  return;
      try {
        const { data } = await this.$api.mappingRenewals.create(params);

        if (data.message) {
            this.notifyError(data.message);
        } else {
            this.notifySuccess('Renewal Mapped');
            this.$router.back()
        }
      } catch (e) {
        this.notifyError('Renewal Mapping failed');
        console.error(e)
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
